import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useCurrencies() {
  const [loading, setLoading] = useState(true);
  const [currencies, setCurrencies] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.currencies.index)
      .then((response) => {
        setCurrencies(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, currencies };
}
